import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly httpClient: HttpClient) { }

  getUser(username: string, database: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'users?username=' + username + '&database=' + database);
  }

  getFleetIdByDb(database: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'fleets/name/' + database);
  }

  getSecurityGroups(): Observable<string[]> {
    return this.httpClient.get<string[]>(environment.apiEndpoint + 'users/security-groups');
  }

  // Creates the "bitc" group and the technical user and links them; only call it in production.
  createGroupAndTechUser(): Observable<any> {
    return this.httpClient.post(environment.apiEndpoint + 'users/create-group-tech-user', {});
  }
}
